<div class="modal fade" id="search-query-info-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Search examples</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-sm small">
          <thead class="thead-light">
            <th>Example</th>
            <th>Matches</th>
            <th>Test</th>
          </thead>
          <tbody>
            <tr>
              <td><code>{{examples[0]}}</code></td>
              <td>docs containing the word <b>cannabis</b>&nbsp;<i>or</i> the word <b>canapa</b>&nbsp;<i>or</i> both together</td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[0])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[1]}}</code></td>
              <td>docs containing the exact phrase <b>recovery fund</b></td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[1])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[2]}}</code></td>
              <td>docs containing the word <b>tobacco</b>&nbsp;<i>or</i> the word <b>beer</b>&nbsp;<i>or</i> both together <i>and not</i> the word <b>wine</b></td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[2])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[3]}}</code></td>
              <td>docs containing the exact phrase <b>louis vuitton</b>&nbsp;<i>or</i> the word <b>prada</b>&nbsp;<i>or</i> the word <b>armani</b>&nbsp;<i>or</i> the exact phrase <b>fashion week</b>&nbsp;<i>or</i> all of them together</td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[3])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[4]}}</code></td>
              <td>docs containing the exact phrase <b>united states</b>&nbsp;<i>or</i> the words <b>americans</b>, <b>americano</b>, etc, <i>or</i> all of them together</td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[4])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[5]}}</code></td>
              <td>docs containing the word <b>vaccine</b>&nbsp;<i>and</i> one of the words <b>pfizer</b>&nbsp;<i>or</i>&nbsp;<b>moderna</b></td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[5])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[6]}}</code></td>
              <td>docs containing the word <b>start-up</b>&nbsp;<i>or</i> the word <b>startup</b>&nbsp;<i>and</i> one of the words <b>incentiv(o/i/are/azione/etc)</b>&nbsp;<i>or</i>&nbsp;<b>agevolaz(ione/ioni/etc)</b>&nbsp;<i>or</i> the exact phrase <b>fondo perduto</b>&nbsp;<i>or</i> all of them together</td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[6])">Test me</button></td>
            </tr>
            <tr>
              <td><code>{{examples[7]}}</code></td>
              <td>docs containing the word <b>energy</b>&nbsp;<i>and</i> the word <b>costs</b> at a maximum distance of <i>5</i> words</td>
              <td><button class="btn btn-outline-primary btn-xs ms-1 py-0 px-1 font-size-sm" data-bs-dismiss="modal" (click)="runAlertQuery(examples[7])">Test me</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>